function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import './header-group';
import './scroll-to';

// only load facets filters and side drawer on collection and search pages
// TODO: when lazy loading of web components feature is finished, we can remove these.
// ! if anything else utilizes the side drawer, we need to move this outside of this conditional.
if (window.location.pathname.includes('collections') || window.location.pathname.includes('search')) {
  import(/* webpackChunkName: "side-drawer" */'../web-components/side-drawer').then(function (module) {
    customElements.define('side-drawer', module.SideDrawer);
  });
  import(/* webpackChunkName: "facets-filters" */'../web-components/facets').then(function (module) {
    customElements.define('facets-filters', module.FacetsFilters);
  });
}
if (document.querySelector('collection-view-more')) {
  import(/* webpackChunkName: "collection-view-more" */'../web-components/collection-view-more').then(function (module) {
    customElements.define('collection-view-more', module.CollectionViewMore);
  });
}
var particleAnimationContainer = document.getElementById('particle-animation-container');
if (particleAnimationContainer) {
  import(/* webpackChunkName: "particle-animation-chunk" */'./particle-animation').then(function (_ref) {
    var ParticleAnimation = _ref.ParticleAnimation;
    return ParticleAnimation.init(particleAnimationContainer);
  });
}
if (!Shopify.designMode) {
  var productCards = document.querySelectorAll('.product_card');
  productCards.forEach(function (productCard) {
    var _productCard$querySel, _productCard$querySel2, _productCard$querySel3, _productCard$querySel4, _productCard$querySel5, _productCard$querySel6;
    var productCardLink = productCard.querySelector('a');
    var gtm_item_name = productCard.querySelector('[name="gtm_item_name"]').getAttribute('value');
    var gtm_item_id = productCard.querySelector('[name="gtm_item_id"]').getAttribute('value');
    var gtm_item_collection = ((_productCard$querySel = productCard.querySelector('[name="gtm_item_collection"]')) === null || _productCard$querySel === void 0 ? void 0 : _productCard$querySel.getAttribute('value')) || '';
    var gtm_item_variant = productCard.querySelector('[name="gtm_item_variant"]').getAttribute('value');
    var gtm_item_upc = productCard.querySelector('[name="gtm_item_upc"]').getAttribute('value');
    var gtm_item_price = productCard.querySelector('[name="gtm_item_price"]').getAttribute('value');
    var gtm_item_sku = (_productCard$querySel2 = productCard.querySelector('[name="gtm_item_sku"]')) === null || _productCard$querySel2 === void 0 ? void 0 : _productCard$querySel2.getAttribute('value');
    var gtm_item_brand = ((_productCard$querySel3 = productCard.querySelector('[name="gtm_item_brand"]')) === null || _productCard$querySel3 === void 0 ? void 0 : _productCard$querySel3.getAttribute('value')) || '';
    var gtm_item_list_id = ((_productCard$querySel4 = productCard.querySelector('[name="gtm_item_list_id"]')) === null || _productCard$querySel4 === void 0 ? void 0 : _productCard$querySel4.getAttribute('value')) || '';
    var gtm_item_list_name = ((_productCard$querySel5 = productCard.querySelector('[name="gtm_item_list_name"]')) === null || _productCard$querySel5 === void 0 ? void 0 : _productCard$querySel5.getAttribute('value')) || '';
    var gtm_item_category = ((_productCard$querySel6 = productCard.querySelector('[name="gtm_item_category"]')) === null || _productCard$querySel6 === void 0 ? void 0 : _productCard$querySel6.getAttribute('value')) || '';
    productCardLink.addEventListener('click', function (e) {
      // console.log(e)
      // console.error('giong to link of product')

      var customEvent = {
        currency: window.currentCurrency,
        items: [{
          item_name: gtm_item_name,
          item_id: gtm_item_id,
          item_category: gtm_item_collection,
          item_variant: gtm_item_variant,
          upc: gtm_item_upc,
          price: parseFloat(gtm_item_price)
        }]
      };
      if (window.shop_iso_code === 'DE') {
        var item = _objectSpread(_objectSpread({}, customEvent.items[0]), {}, {
          category: gtm_item_category,
          item_brand: gtm_item_brand,
          item_sku: gtm_item_sku,
          item_group_id: gtm_item_sku.slice(0, 6),
          item_list_name: gtm_item_list_name,
          item_list_id: gtm_item_list_id
        });
        Object.assign(customEvent, {
          value: gtm_item_price,
          items: [item]
        });
      }
      Shopify.analytics.publish('product_card_selected', customEvent);
    });
  });
}
document.addEventListener('DOMContentLoaded', function () {
  // Update Cookie Consent Privacy Policy Links
  var targetNode = document.body;
  var config = {
    childList: true,
    subtree: true
  };
  var privacyPolicyUrl = '/policies/privacy-policy';
  var hasCompletedConsent = function hasCompletedConsent() {
    return document.cookie.split(';').some(function (item) {
      var cookie = item.trim().split('=');
      return cookie[0] === '_evidon_consent_cookie' || cookie[0] === '_evidon_suppress_notification_cookie';
    });
  };
  if (!hasCompletedConsent()) {
    var privacyConsentObserver = new MutationObserver(function (mutationsList, observer) {
      var evidonBanner = document.getElementById('_evidon-message');
      var evidonPopup = document.getElementById('prc-message');
      var evidonPopupMenu = document.getElementById('evidon-prefdiag-nav-1');

      // Cookie Consent Banner
      if (evidonBanner) {
        var privacyPolicyLinks = evidonBanner.querySelectorAll('a[href*="https://privacy.umusic.com"]');
        if (privacyPolicyLinks) {
          privacyPolicyLinks.forEach(function (link) {
            link.href = privacyPolicyUrl;
          });
        }
      }
      // Cookie Consent Popup
      if (evidonPopup) {
        var _privacyPolicyLinks = evidonPopup.querySelectorAll('a[href*="https://privacy.umusic.com"]');
        if (_privacyPolicyLinks) {
          _privacyPolicyLinks.forEach(function (link) {
            link.href = privacyPolicyUrl;
          });
        }
      }
      // Cookie Consent Popup 2nd link
      if (evidonPopupMenu) {
        evidonPopupMenu.addEventListener('click', function (event) {
          event.stopPropagation();
          window.open(privacyPolicyUrl, '_blank');
        }, true);
      }
    });

    // Begin observing the target node for configured mutations
    privacyConsentObserver.observe(targetNode, config);
  }
  // End - Update Cookie Consent Privacy Policy Links
});

// only load carousel when .swiper__parent is present
var carouselNodes = document.querySelectorAll('.swiper__parent');
if (carouselNodes.length > 0) {
  import(/* webpackChunkName: "carousel-import" */'./carousel').then(function (module) {
    return module.carouselInit();
  });
}
document.addEventListener('DOMContentLoaded', function () {
  // Select all video elements with the "lazy-video" class
  var lazyVideos = Array.from(document.querySelectorAll('video.lazy-video'));

  // Intersection Observer options
  var observerOptions = {
    root: null,
    rootMargin: '30px',
    threshold: 0.2
  };

  /**
   * Sets the source for all <source> children of a video element and starts playback.
   * @param {HTMLVideoElement} video - The video element to load and play.
   * @param {Boolean} play - Play video for media section.
   */
  var setVideoSrcAndPlayVideo = function setVideoSrcAndPlayVideo(video, play) {
    // Loop through all children of the video element
    Array.from(video.children).forEach(function (child) {
      if (child.tagName === 'SOURCE') {
        child.src = child.dataset.src;
      }
    });
    video.load();
    if (play) {
      video.play();
    }
  };

  /**
   * Checks for a play button associated with the video and attaches click events.
   * If no button exists, loads and plays the video immediately.
   * @param {HTMLVideoElement} video - The video element to check.
   * @param {Boolean} isAutoplay - Is Autoplay video or not.
   */
  var handlePlayButton = function handlePlayButton(video, isAutoplay) {
    var playButton = video.previousElementSibling; // Assume the button is the previous sibling
    if (playButton && playButton.tagName === 'BUTTON') {
      playButton.addEventListener('click', function () {
        setVideoSrcAndPlayVideo(video, true);
      });
    } else {
      // No play button, load and play the video directly
      setVideoSrcAndPlayVideo(video, !isAutoplay);
    }
  };

  /**
   * Applies an Intersection Observer to a lazy-loaded video element.
   * @param {HTMLVideoElement} lazyVideo - The lazy-loaded video element.
   * @param {Boolean} isAutoplay - Is Autoplay video or not.
   */
  var observeLazyVideo = function observeLazyVideo(lazyVideo, isAutoplay) {
    var observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // When the video is in the viewport, handle playback
          handlePlayButton(entry.target, isAutoplay);
          entry.target.classList.remove('lazy-video');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    observer.observe(lazyVideo);
  };

  // Iterate through each lazy video and set up the observer or fallback
  lazyVideos.forEach(function (lazyVideo) {
    var isAutoplay = lazyVideo.getAttribute('autoplay');
    if ('IntersectionObserver' in window) {
      // Use Intersection Observer if supported
      observeLazyVideo(lazyVideo, isAutoplay);
    } else {
      // Fallback: handle video playback immediately
      handlePlayButton(lazyVideo);
    }
  });
});